export enum DynamicPriceRulesQueryOperator {
    Equal = '=',
    NotEqual = '!=',
    Greater = '>',
    GreaterOrEqual = '>=',
    Smaller = '<',
    SmallerOrEqual = '<=',
    Includes = 'enthält',
    NotIncludes = 'enthält nicht'
}
